class Controller  
  @$inject: ["$rootScope", "$scope", "$state", "$stateParams", "toasty", "editor", "selector", "mover", "warning", "Resource"]  
  constructor: ($rootScope, $scope, $state, $stateParams, toasty, editor, selector, mover, warning, Resource)->    
    $scope.$watch "current", (val)->
      if val
        options = 
          _id: val._id        
        Resource.parents(options).$promise.then (parents)->
          $scope.parents = parents
      else
        $scope.parents = []
    
    $scope.pageTitle = "Apps & Resources";

    $scope.create = ($resource)->      
      folder = new Resource()
      $scope.edit folder, $resource

    $scope.edit = (resource, $resource)->      
      options =         
        title: 'Edit Resource'
        source: resource
        schema:
          name:
            display: "Resource Name"
            type: "String"
            required: true
      editor.edit(options).then (result)->
        result.folder = $scope.current?._id
        result.$save()
      .then (result)->        
        $resource.query()
        toasty.success
          title: 'Edit Resource Success'
          msg: "Edit resource #{result.name} success"

    $scope.move = (resource, $resource)->        
      mover.move().then (folder)->
        if folder?
          resource.folder = folder._id            
        else
          resource.folder = null        
        resource.$save()
      .then ()=>            
        $resource.query()    
        toasty.success
          title: 'Move Success'
          msg: "Move Resource #{resource.name} success"

    $scope.upload = ($resource, $files)->
      $files.forEach (file)->
        if not $scope.uploading
          $scope.uploading = []
        $scope.uploading.push file
        Resource.upload(file, $scope.current).then ()->
          idx = $scope.uploading.indexOf(file)
          $scope.uploading.splice(idx, 1)
          $resource.query()
          toasty.success
            title: 'Upload Success'
            msg: "Upload Resource #{file.name} success"

    $scope.assign = (resource)->
      opts = 
        model: "Company"
        multi: true
        fields:[
          {value: "name", display: "Name"}
        ]

      selector.select(opts).then (companies)->
        companies.forEach (company)->
          resource.$assign(company)          
        toasty.success
          title: 'Assign Resource Success'
          msg: "Assign resource #{resource.name} success"

    edit = 
      html: "<a><i class='fa fa-pencil'></i>Edit Info</a>"
      enabled: (scope)-> true
      click: (scope) =>
        {resource, $resource} = scope
        $scope.edit resource, $resource
        # resource.$download()    
    move = 
      html: "<a><i class='fa fa-arrows-h'></i>Move</a>"
      enabled: (scope)-> true
      click: (scope) =>
        {resource, $resource} = scope
        $scope.move resource, $resource
    download = 
      html: "<a><i class='fa fa-download'></i>Download</a>"
      enabled: (scope)-> 
        {resource} = scope
        if resource.type is "FOLDER"
          return false
        return true
      click: (scope) =>
        {resource} = scope
        resource.$download()

    assign = 
      html: "<a><i class='fa fa-share'></i>Assign</a>"
      enabled: -> true
      click: (scope) =>
        {resource} = scope
        $scope.assign resource

    remove =
      html: "<a><i class='fa fa-trash'></i>Remove</a>"
      enabled: -> true
      click: (scope) =>
        {resource, $resource} = scope        
        options = 
          title: "Remove Resource #{resource.name}"
        if resource.shared
          options.msg = "#{resource.name} was shared to other company, would you confirm to remove this?"
        else
          options.msg = "Would you confirm to remove this?"
        warning.warn(options).then ()->      
          resource.$remove()
        .then ()=>
          $resource.query()
          toasty.success
            title: 'Remove Success'
            msg: "Remove Resource #{resource.name} success"
    

    $scope.menu = [edit, move, assign, remove]
    $rootScope.$watch "user", (val)=>
      if val?.company and not val.company.parent
        if $scope.menu.indexOf(download) < 0
          $scope.menu.splice(1, 0, download)



module.exports = Controller




// WEBPACK FOOTER //
// ./src/component/resource/controller.coffee